import Vue from "vue";
import Router from "vue-router";
import adminIndex from "@/components/index";
import meetings from "@/components/frontend/meeting";
import fehkstockspost from "@/components/frontend/hkstocks";
import fefreetalkspost from "@/components/frontend/freetalks";
import ferank from "@/components/frontend/rank";
import feenroll from "@/components/frontend/enroll";
import feroadshowpost from "@/components/frontend/roadshow";
import otherCompany from "@/components/frontend/other";
import hiringStand from "@/components/frontend/hiringStand";

import estateforum_cheack_ticket from "@/components/backend/estateforum/estateforum-cheack-ticket";
import estateforum_companypost from "@/components/frontend/estateforum/estateforum-company";
import estateforum_personpost from "@/components/frontend/estateforum/estateforum-person";
import estateforum_pay from "@/components/frontend/estateforum/pay";
import estateforum_back_list from "@/components/backend/estateforum/estateforum";
import estateforum_company_status_list from "@/components/backend/estateforum/estateforum_company";
import estateforum_users_status_list from "@/components/backend/estateforum/estateforum_users";
import estateforum_users_sms_list from "@/components/backend/estateforum/estateforum_users_sms";
import promotion_code from "@/components/backend/estateforum/promotion_code";

import rank from "@/components/backend/rank/rank_list";
import enroll from "@/components/backend/enroll/enroll_list";

import activities from "@/components/frontend/index";
import cityinfo from "@/components/frontend/cityInfo";
import defaults from "@/components/backend/default";
import freetalks from "@/components/backend/freetalks";
import freetalkspost from "@/components/backend/freetalkspost";
import roadshow from "@/components/backend/roadshow";
import roadshowpost from "@/components/backend/roadshowpost";
import hkstocks from "@/components/backend/hkstocks";
import hkstockspost from "@/components/backend/hkstockspost";
import guestList from "@/components/backend/guest-list";
import guestPost from "@/components/backend/guest-post";
import newsList from "@/components/backend/news-list";
import newsPost from "@/components/backend/news-post";
import agendaAMList from "@/components/backend/agenda-list";
import agendaAMPost from "@/components/backend/agenda-post";

import hiringStandList from "@/components/backend/hiringStandList";

import agendaPMList from "@/components/backend/agenda-pm-list";
import agendaPMPost from "@/components/backend/agenda-pm-post";

import showsList from "@/components/backend/show-list";
import showsPost from "@/components/backend/show-post";
import parthersList from "@/components/backend/parthers-list";
import parthersPost from "@/components/backend/parthers-post";

import adminusers from "@/components/backend/adminusers";
import meetingusers from "@/components/backend/meetingusers";
import login from "@/components/backend/login";
import register from "@/components/backend/register";
import sms from "@/components/backend/sms";
import acUsers from "@/components/backend/meetingUsersList";
import errors from "@/components/error";
import midGuide from "@/components/frontend/midGuide";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/manage",
      component: adminIndex,
      children: [
        {
          path: "",
          component: defaults,
          name: "defaults"
        },
        {
          path: "/hiringStandList",
          component: hiringStandList,
          name: "hiringStandList"
        },
        {
          path: "/freetalks",
          component: freetalks,
          name: "freetalks"
        },
        {
          path: "/freetalks/post/:id?",
          component: freetalkspost,
          name: "freetalkspost"
        },
        {
          path: "/roadshow",
          component: roadshow,
          name: "roadshow"
        },
        {
          path: "/roadshow/post/:id?",
          component: roadshowpost,
          name: "roadshowpost"
        },
        {
          path: "/hkstocks",
          component: hkstocks,
          name: "hkstocks"
        },
        {
          path: "/hkstocks/post/:id?",
          component: hkstockspost,
          name: "hkstockspost"
        },
        {
          path: "/rank",
          component: rank,
          name: "rank"
        },
        {
          path: "/enroll",
          component: enroll,
          name: "enroll"
        },
        {
          path: "/guest/list",
          component: guestList,
          name: "guestList"
        },
        {
          path: "/guest/post/:id?",
          component: guestPost,
          name: "guestPost"
        },
        {
          path: "/news/list",
          component: newsList,
          name: "newsList"
        },
        {
          path: "/news/post/:id?",
          component: newsPost,
          name: "newsPost"
        },
        {
          path: "/agenda/am/list",
          component: agendaAMList,
          name: "agendaAMList"
        },
        {
          path: "/agenda/am/post/:type?/:acid?/:id?",
          component: agendaAMPost,
          name: "agendaAMPost"
        },
        {
          path: "/agenda/pm/list",
          component: agendaPMList,
          name: "agendaPMList"
        },
        {
          path: "/agenda/pm/post/:type?/:acid?/:id?",
          component: agendaPMPost,
          name: "agendaPMPost"
        },
        {
          path: "/shows/list",
          component: showsList,
          name: "showsList"
        },
        {
          path: "/shows/post/:id?",
          component: showsPost,
          name: "showsPost"
        },
        {
          path: "/parthers/list",
          component: parthersList,
          name: "parthersList"
        },
        {
          path: "/parthers/post/:id?",
          component: parthersPost,
          name: "parthersPost"
        },
        {
          path: "/admin/users",
          component: adminusers,
          name: "adminusers"
        },
        {
          path: "/meeting/users",
          component: meetingusers,
          name: "meetingusers"
        },
        {
          path: "/users/:acType/:acId",
          component: acUsers,
          name: "actypeusers"
        },
        {
          path: "/sms/:type/:id",
          component: sms,
          name: "smsService"
        },
        {
          path: "/estateforum_back_list",
          component: estateforum_back_list,
          name: "estateforum_back_list"
        },
        {
          path: "/estateforum_company_status_list/:acid?",
          component: estateforum_company_status_list,
          name: "estateforum_company_status_list"
        },
        {
          path: "/estateforum_users_status_list/:acid?",
          component: estateforum_users_status_list,
          name: "estateforum_users_status_list"
        },
        {
          path: "/estateforum/promotion_code",
          component: promotion_code,
          name: "promotion_code"
        },
        {
          path: "/estateforum_cheack",
          component: estateforum_cheack_ticket,
          name: "estateforum_cheack_ticket"
        }
      ]
    },
    {
      path: "/activities",
      name: "activitiesdetail",
      component: activities
    },
    {
      path: "/meetings",
      component: cityinfo,
      name: "meetingsindex"
    },
    {
      path: "/cityinfo",
      component: cityinfo,
      name: "cityinfomations"
    },
    {
      path: "/meetings/hkstocks",
      component: fehkstockspost,
      name: "fehkstockspost"
    },
    {
      path: "/meetings/rank",
      component: ferank,
      name: "ferank"
    },
    {
      path: "/meetings/enroll/:id",
      component: feenroll,
      name: "feenroll"
    },
    {
      path: "/meetings/registration/:id",
      component: () => import("@/components/frontend/registration"),
      name: "meetingsRegistrationId"
    },
    {
      path: "/meetings/freetalks",
      component: fefreetalkspost,
      name: "fefreetalkspost"
    },
    {
      path: "/meetings/roadshow",
      component: feroadshowpost,
      name: "feroadshowpost"
    },
    {
      path: "/meetings/security",
      component: otherCompany,
      name: "otherCompany"
    },
    {
      path: "/meetings/hiringStand",
      component: hiringStand,
      name: "hiringStand"
    },
    {
      path: "/meetings/estateforum_company",
      component: estateforum_companypost,
      name: "estateforum_companypost"
    },
    {
      path: "/meetings/estateforum_person",
      component: estateforum_personpost,
      name: "estateforum_personpost"
    },
    {
      path: "/login",
      name: "loginform",
      component: login
    },
    {
      path: "/register",
      name: "register",
      component: register
    },
    {
      path: "/midGuide",
      component: midGuide,
      name: "midGuide"
    },
    {
      path: "*",
      name: "page404",
      component: errors
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js